const globalStyles = {
    borderRadius: "0.5rem",
    padding: "0.5rem 1rem",
    margin: "0.5rem 1rem",
    green: "#099709",
    red: "#c90808",
    gray: "#808080"
};

export const lightTheme = {
    body: "#eee",
    text: "#333",
    ...globalStyles
};

export const darkTheme = {
    body: "#363537",
    text: "#FAFAFA",
    ...globalStyles
};
